import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fallback"]
  static values = {
    url: String,
    newTab: { type: Boolean, default: true }
  }

  connect() {
    this.open()
  }

  open() {
    if (!this.hasUrlValue || this.urlValue.length === 0) {
      this.showFallback()
      return
    }

    const target = this.newTabValue ? "_blank" : "_self"
    const opened = window.open(this.urlValue, target)
    if (opened) {
      opened.opener = null
      if (opened.focus) opened.focus()
      return
    }

    this.showFallback()
  }

  showFallback() {
    if (this.hasFallbackTarget) {
      this.fallbackTarget.hidden = false
    }
  }
}
